import { component } from 'picoapp'
import '@/lib/jquery-global.js';

export default component(({ node }) => {

    jQuery('.js-testimonials').slick({
        arrows: false,
        asNavFor: '.js-testimonials-nav',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    jQuery('.js-testimonials-nav').slick({
        slidesToShow: 4,
        arrows: false,
        asNavFor: '.js-testimonials',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    dots: true
                }
            }
        ]
    });
    
    jQuery('.js-testimonials-image').click(function() {
        let index = jQuery(this).data('index');
        jQuery('.js-testimonials').slick('slickGoTo', index);
    });

})
